import ForgotPasswordSubmitPage from './ForgotPasswordSubmitPage';

export default ForgotPasswordSubmitPage;
